export default __webpack_public_path__ + "static/media/logo2.3e09d708.mp4";